/**
 * HTML Element
 *
 */

import Th from '../components/table/TableTh'
export * from '../components/table/TableTh'
export default Th
